import React from 'react';
import { useRive } from '@rive-app/react-canvas';

interface RiveComponentProps {
    src: string;
    stateMachine?: string;
    autoplay?: boolean;
    artboard?: string;
}

export function RiveComponent({ src, stateMachine, autoplay, artboard }: RiveComponentProps): React.ReactElement {
    const { RiveComponent } = useRive({
        src,
        stateMachines: stateMachine,
        autoplay,
        artboard,
        automaticallyHandleEvents: true,
    });

    return <RiveComponent />;
}
